module.exports = __webpack_public_path__ + "static/media/icons_Evaluation MDT des Membres Inf‚rieurs.dd8c4c84.svg";